/* COPYRIGHT Esri - https://js.arcgis.com/5.1/LICENSE.txt */
const CSS = {
  container: "container",
  actionsStart: "actions-start",
  contentStart: "content-start",
  content: "content",
  contentEnd: "content-end",
  actionsEnd: "actions-end"
};
const SLOTS = {
  actionsStart: "actions-start",
  contentStart: "content-start",
  contentEnd: "content-end",
  actionsEnd: "actions-end"
};
export {
  CSS as C,
  SLOTS as S
};
